<template>
  <b-container id="about">
    <div class="section section-about">
      <h1>POVESTEA MUSTAȚĂ DE BERE</h1>
      <img src="./../assets/mustata-only.png" alt class="logo-mustata" />
      <b-row align-h="center">
        <b-col cols="10">
          <p>Mustața de Bere a apărut din dorința de a lucra și locui în Brașov, fără a fi nevoiți să facem asta în alte țări. Am pornit cu ideea să creăm un produs de care să fim mândri, pe care clienții să îl recunoască dintr-o gustare și să îl recomande cu entuziasm mai departe.</p>
          <p>Gustul deosebit este obținut din ingrediente naturale de calitate, rețete unice și tehnologie de ultimă oră. Mustața de Bere se găsește în 4 sortimente, fiecare cu particularități fermecătoare.</p>
        </b-col>
      </b-row>
      <b-row class="line-height" align-h="center" cols="2" cols-sm="2" cols-lg="4">
        <b-col>
          <img src="./../assets/bottles/ipa-3.png" alt="Mustața de Bere Ipa" class="bottles" />
          <h6>IPA</h6>
          <span>gust amărui, aromă fructată obținută din hameiul cascade și amarillo</span>
        </b-col>
        <b-col>
          <img src="./../assets/bottles/alba-3.png" alt="Mustața de Bere Albă" class="bottles" />
          <h6>ALBĂ</h6>
          <span>
            gust ușor dulceag,
            <br />aromat și lejer
          </span>
        </b-col>
        <b-col>
          <img src="./../assets/bottles/blonda-3.png" alt="Mustața de Bere Blondă" class="bottles" />
          <h6>BLONDĂ</h6>
          <span>
            gust ușor amărui,
            <br />clasic și gustos
          </span>
        </b-col>
        <b-col>
          <img src="./../assets/bottles/french-3.png" alt="Mustața de Bere French" class="bottles" />
          <h6>FRENCH AMBER</h6>
          <span>gust ușor amărui, aromat, cu note dulci datorită malțului prăjit</span>
        </b-col>
      </b-row>
    </div>
  </b-container>
</template>

<script>
export default {
  name: "About"
};
</script>

<style>
.section-about p {
  margin-top: 20px;
}

.section-about h6 {
  font-size: 14px;
  font-weight: 600;
}
.section-about span {
  font-size: 12px;
  color: #8b4e2e;
}

.line-height {
  line-height: 1.1;
}

.bottles {
  padding: 20px;
  max-height: 450px;
}

.section {
  text-align: center;
}
</style>
